import { render } from "./Logon.vue?vue&type=template&id=4d80c02d"
import script from "./Logon.vue?vue&type=script&lang=js"
export * from "./Logon.vue?vue&type=script&lang=js"

import "./Logon.vue?vue&type=style&index=0&id=4d80c02d&lang=scss&scroped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__